export default "__VITE_ASSET__CHsZbP5I__"